import preferences from "@coworker/enums/profilePreferences";
import { useUserPreference } from "../../hooks/useProfilePreferencesQuery";
import { getShellLanguage } from "../shellLanguage";

/**
 * Shared locale accessor for the app.
 *
 * When the Flexa shell provides a locale via `ShellContext.intl.locale` (the
 * embedded/MFE case), it is the source of truth and wins over the backend user
 * preference. Falls back to the backend `LANGUAGE` preference when running
 * standalone. In both cases the value is the IKEA underscore form (e.g.
 * `sv_SE`).
 *
 * Routing every locale consumer (`useFormatter`, the SIK search hooks, etc.)
 * through this accessor keeps translations, date/number formatting and search
 * behavior aligned with the language the shell actually renders in.
 */
export function useLanguage(): string {
  const [userLanguage] = useUserPreference(preferences.LANGUAGE, "");
  return getShellLanguage() ?? userLanguage;
}
